import { render, staticRenderFns } from "./bill_info.vue?vue&type=template&id=9d78c38e"
import script from "./bill_info.vue?vue&type=script&lang=js"
export * from "./bill_info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports